import { createFileRoute } from "@tanstack/react-router";

import { ChatDetailsPage } from "src/pages/ChatDetailsPage";

export const Route = createFileRoute("/_auth/chat/$chatId")({
  component: ChatDetailsPage,
});
